module.exports = __webpack_public_path__ + "static/media/supprimer.b59ac26f.png";